import Pagination from "@mui/material/Pagination";

function Paginacion({ data }) {
  const { cantPag, fnList, fnPag, completeList, listar, animacion } = data;
  const handleChange = (e, p) => {
    fnPag(p);
    fnList(listar(p, completeList));
    animacion.fn(true);
  };
  return (
    <div>
      <Pagination
        count={cantPag}
        variant="outlined"
        color="primary"
        onChange={handleChange}
      />
    </div>
  );
}

export default Paginacion;
